import React from 'react';

export default function ScreenShareIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4997 25.6667H17.4997C23.333 25.6667 25.6663 23.3334 25.6663 17.5V10.5C25.6663 4.66671 23.333 2.33337 17.4997 2.33337H10.4997C4.66634 2.33337 2.33301 4.66671 2.33301 10.5V17.5C2.33301 23.3334 4.66634 25.6667 10.4997 25.6667Z"
        stroke="#1E2E5E"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 11.095L14 7.59497L17.5 11.095"
        stroke="#1E2E5E"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14 7.59497V16.9283" stroke="#1E2E5E" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7 19.2617C11.5383 20.7784 16.4617 20.7784 21 19.2617"
        stroke="#1E2E5E"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
